<template>
  <div class="wrapper app-content">
    <div class="tilte-text"> 会员排名 </div>
    <div class="sort-wrap">
      <div class="tab-box">
        <div class="tab-div" :class="tabActive == 0 ? 'active' : ''" @click="changeTab(0)">
          <span>订单排名</span>
          <div class="line" v-if="tabActive == 0"></div>
        </div>
        <div class="tab-div" :class="tabActive == 1 ? 'active' : ''" @click="changeTab(1)">
          <span>佣金排名</span>
          <div class="line" v-if="tabActive == 1"></div>
        </div>
        <div class="tab-div" :class="tabActive == 2 ? 'active' : ''" @click="changeTab(2)">
          <span>团队排名</span>
          <div class="line" v-if="tabActive == 2"></div>
        </div>
      </div>
      <div class="main-wrapper">
        <!--订单排名-->
        <div v-if="tabActive == 0">
          <div class="search-wrap">
            <div class="search-item">
              <Input v-model="searchOrderForm.id" placeholder="会员ID" style="width: 150px;" />
            </div>
            <div class="search-item">
              <Button type="text" style="background: #FF8622;color: #FFFFFF;" @click="getOrderList">查询</Button>
            </div>
          </div>
          <div class="table-wrapper">
            <Table border :columns="orderColumns" :data="orderList" :loading="listLoading">
            </Table>
          </div>
          <div style="padding: 10px 0px">
            <Page :total="totalOrder" :current="searchOrderForm.pageNo" show-sizer show-elevator show-total
              @on-change="changePageOrder" @on-page-size-change="changePagesizeOrder"></Page>
          </div>
        </div>
        <!--订单排名-->
        <!--佣金排名-->
        <div v-if="tabActive == 1">
          <div class="search-wrap">
            <div class="search-item">
              <span>排名方式：</span>
              <RadioGroup v-model="searchProfitForm.rankType">
                <Radio label="1">
                  <span>累计佣金</span>
                </Radio>
                <Radio label="2">
                  <span>已提现佣金</span>
                </Radio>
              </RadioGroup>
            </div>
            <div class="search-item">
              <Input v-model="searchProfitForm.id" placeholder="会员ID" style="width: 150px;" />
            </div>
            <div class="search-item">
              <Button type="text" style="background: #FF8622;color: #FFFFFF;" @click="getProfitList">查询</Button>
            </div>
          </div>
          <div class="table-wrapper">
            <Table border :columns="profitColumns" :data="profitList" :loading="listLoading">
            </Table>
          </div>
          <div style="padding: 10px 0px">
            <Page :total="totalProfit" :current="searchProfitForm.pageNo" show-sizer show-elevator show-total
              @on-change="changePageProfit" @on-page-size-change="changePagesizeProfit"></Page>
          </div>
        </div>
        <!--佣金排名-->
        <!--团队排名-->
        <div v-if="tabActive == 2">
          <div class="search-wrap">
            <div class="search-item">
              <span>排名方式：</span>
              <RadioGroup v-model="searchTeamForm.rankType">
                <Radio label="4">
                  <span>直推团队</span>
                </Radio>
                <Radio label="5">
                  <span>二级团队</span>
                </Radio>
              </RadioGroup>
            </div>
            <div class="search-item">
              <Input v-model="searchTeamForm.id" placeholder="会员ID" style="width: 150px;" />
            </div>
            <div class="search-item">
              <Button type="text" style="background: #FF8622;color: #FFFFFF;" @click="getTeamList">查询</Button>
            </div>
          </div>
          <div class="table-wrapper">
            <Table border :columns="teamColumns" :data="teamList" :loading="listLoading">
            </Table>
          </div>
          <div style="padding: 10px 0px">
            <Page :total="totalTeam" :current="searchTeamForm.pageNo" show-sizer show-elevator show-total
              @on-change="changePageTeam" @on-page-size-change="changePagesizeTeam"></Page>
          </div>
        </div>
        <!--团队排名-->
      </div>
    </div>
  </div>
</template>

<script>
import { getPlatformUuid } from '@/utils/auth'
import { Table, Button, Input, RadioGroup, Radio, Page } from 'view-design'
import { numFormatter } from '@/utils/date'
import sort from '@/javaApi/sort'
const sortModel = new sort()
export default {
  name: "Sort",
  components: {
    Table,
    Button,
    Input,
    RadioGroup,
    Radio,
    Page
  },
  data: function () {
    return {
      tabActive: 0,
      listLoading: false,
      totalOrder: 0,
      orderList: [],
      searchOrderForm: {
        pageNo: 1,
        pageSize: 10,
        rankType: '0', //排名方式 0:订单数量 1:累计佣金 2:已提现佣金 3:团队人数 4:直推团队 5:二级团队
        id: undefined,
      },
      orderColumns: [
        {
          title: '排名',
          key: 'sequence'
        },
        {
          title: '会员ID',
          key: 'id'
        },
        {
          title: '订单数量',
          key: 'orderNum'
        },
        {
          title: '注册时间',
          key: 'createTimeStr'
        }
      ],
      totalProfit: 0,
      profitList: [],
      searchProfitForm: {
        pageNo: 1,
        pageSize: 10,
        rankType: '1',//排名方式 0:订单数量 1:累计佣金 2:已提现佣金 3:团队人数 4:直推团队 5:二级团队
        id: undefined,
      },
      profitColumns: [
        {
          title: '排名',
          key: 'sequence'
        },
        {
          title: '会员ID',
          key: 'id'
        },
        {
          title: '累计佣金',
          key: 'commission'
        },
        {
          title: '已提现佣金',
          key: 'withdraw'
        },
        {
          title: '剩余佣金',
          key: 'balance'
        },
        {
          title: '注册时间',
          key: 'createTimeStr'
        }
      ],
      totalTeam: 0,
      teamList: [],
      searchTeamForm: {
        pageNo: 1,
        pageSize: 10,
        rankType: '4',//排名方式 0:订单数量 1:累计佣金 2:已提现佣金 3:团队人数 4:直推团队 5:二级团队
        id: undefined,
      },
      teamColumns: [
        {
          title: '排名',
          key: 'sequence'
        },
        {
          title: '会员ID',
          key: 'id'
        },
        {
          title: '团队人数',
          key: 'teamNum'
        },
        {
          title: '直推数量',
          key: 'directNum'
        },
        {
          title: '二级数量',
          key: 'secondNum'
        },
        {
          title: '注册时间',
          key: 'createTimeStr'
        }
      ],
      platformUuid: getPlatformUuid(),
    }
  },
  created() {
    //订单排名
    this.getOrderList();
    //佣金排名
    this.getProfitList();
    //团队排名
    this.getTeamList();
  },
  computed: {
    profitRankType() {
      return this.searchProfitForm.rankType;
    },
    teamRankType() {
      return this.searchTeamForm.rankType;
    }
  },
  watch: {
    profitRankType() {
      this.searchProfitForm.pageNo = 1;
    },
    teamRankType() {
      this.searchTeamForm.pageNo = 1;
    }
  },
  methods: {
    changeTab: function (index) {
      this.tabActive = index;
    },
    getOrderList() {
      let userParam = this.searchOrderForm;
      this.listLoading = true
      let that = this
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if (!condition) {
        userParam.platformUuid = this.platformUuid
      }
      userParam = this.formateInit(userParam)
      if (userParam.id) {
        userParam.id = numFormatter(userParam.id)
      }
      that.listLoading = false
      sortModel.getOrderList(userParam).then(response => {
        console.log(response)
        let res = response.data
        if (res.code === 200) {
          that.listLoading = false
          that.orderList = res.data ? res.data.list : []
          that.orderList = that.formateData(that.orderList, userParam.pageNo, userParam.pageSize)
          that.totalOrder = res.data.total;
        } else {
          that.listLoading = false
          // let message = res.message?res.message:'系统繁忙请稍后再试！'
          // this.$message.error(message)
        }
      }).catch(error => {
        that.listLoading = false
        if (error != 'token invalid') {
          this.$message.error('系统繁忙请稍后再试!')
        }

      })

    },
    getProfitList() {
      let userParam = this.searchProfitForm;
      this.listLoading = true
      let that = this
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if (!condition) {
        userParam.platformUuid = this.platformUuid
      }
      userParam = this.formateInit(userParam)
      if (userParam.id) {
        userParam.id = numFormatter(userParam.id)
      }
      that.listLoading = false
      sortModel.getCommissionList(userParam).then(response => {
        console.log(response)
        let res = response.data
        if (res.code === 200) {
          that.listLoading = false
          that.profitList = res.data ? res.data.list : []
          that.profitList = that.formateData(that.profitList, userParam.pageNo, userParam.pageSize)
          that.totalProfit = res.data.total;
        } else {
          that.listLoading = false
          // let message = res.message?res.message:'系统繁忙请稍后再试！'
          // this.$message.error(message)
        }
      }).catch(error => {
        that.listLoading = false
        if (error != 'token invalid') {
          this.$message.error('系统繁忙请稍后再试!')
        }

      })

    },
    getTeamList() {
      let userParam = this.searchTeamForm;
      this.listLoading = true
      let that = this
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if (!condition) {
        userParam.platformUuid = this.platformUuid
      }
      userParam = this.formateInit(userParam)
      if (userParam.id) {
        userParam.id = numFormatter(userParam.id)
      }
      that.listLoading = false
      sortModel.getTeamList(userParam).then(response => {
        console.log(response)
        let res = response.data
        if (res.code === 200) {
          that.listLoading = false
          that.teamList = res.data ? res.data.list : []
          that.teamList = that.formateData(that.teamList, userParam.pageNo, userParam.pageSize)
          that.totalTeam = res.data.total;
        } else {
          that.listLoading = false
          // let message = res.message?res.message:'系统繁忙请稍后再试！'
          // this.$message.error(message)
        }
      }).catch(error => {
        that.listLoading = false
        if (error != 'token invalid') {
          this.$message.error('系统繁忙请稍后再试!')
        }

      })
    },
    formateInit(formData) {
      let objCopy = {};
      for (let key in formData) {
        if (formData[key]) {
          objCopy[key] = formData[key];
        }
      }
      return objCopy;
    },
    formateData(data, pageNo, pageSize) {
      if (!data) {
        return []
      }
      if (!data.length) {
        return []
      }
      let i = 0;
      for (i = 0; i < data.length; i++) {
        data[i].sequence = (i + 1) + (pageNo - 1) * pageSize
      }
      return data
    },
    changePageOrder(value) {
      this.searchOrderForm.pageNo = value
      this.getOrderList()
    },
    changePagesizeOrder(value) {
      this.searchOrderForm.pageSize = value;
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchOrderForm.pageNo == 1) {
        this.getOrderList()
      }
    },
    changePageProfit(value) {
      this.searchProfitForm.pageNo = value
      this.getProfitList()
    },
    changePagesizeProfit(value) {
      this.searchProfitForm.pageSize = value;
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchProfitForm.pageNo == 1) {
        this.getProfitList()
      }
    },
    changePageTeam(value) {
      this.searchTeamForm.pageNo = value
      this.getTeamList()
    },
    changePagesizeTeam(value) {
      this.searchTeamForm.pageSize = value;
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchTeamForm.pageNo == 1) {
        this.getTeamList()
      }
    },
  }
}
</script>

<style lang="less" scoped>
.sort-wrap {
  .tab-box {
    padding-top: 27px;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #EEEEEE;

    .tab-div {
      padding: 0 20px;
      font-size: 16px;
      color: #999999;
      line-height: 28px;
      cursor: pointer;
    }

    .tab-div.active {
      color: #FF8622;
    }

    .tab-div .line {
      background: #FF8622;
      height: 2px;
    }
  }
}

.wrapper {
  width: 100%;
  font-size: 12px;
}

.wrapper .tilte-text {
  font-size: 18px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper .table-wrapper {
  margin-top: 30px;
}

.ivu-date-picker-rel {
  margin: 11px 0;
}

.ivu-table {
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  border-radius: 2px;
}

.table-wrapper .ivu-table-header th {
  background-color: #FCFAF8 !important;
}

.table-wrapper .ivu-table-header th .ivu-table-cell {
  color: #222222 !important;
}

.table-wrapper .ivu-table-wrapper-with-border {
  border: none;
}

.table-wrapper .ivu-table-wrapper-with-border {
  border-radius: 0px;
  border-color: #FFFFFF !important;
}

.div-flex {
  display: flex;
  flex-wrap: wrap;
}

.div-flex .color-ff4 {
  width: 50%;
}
</style>
<style lang="less" scoped>
.search-wrap {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;

  .ivu-input-wrapper {
    margin-right: 10px;
  }

  .search-item {
    font-size: 14px;
    margin-left: 10px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/official/sort/Index.vue